<div fxLayout="column" fxLayoutAlign="center center" style="height: 100vh; position: fixed; background-color: white; top: 0; width: 100%;">

  <div fxFill="100" fxLayout="column" fxLayoutAlign="center center" *ngIf="!errorState">
    <h1>{{ "Signing is complete, you are being redirected back to the form." | translate }}</h1>
    <mat-icon
    style="
    color: green;
    font-size: 5rem;
    width: max-content;
    height: auto;"> check_circle</mat-icon>
    <div></div>
    <span>
        <a style="text-decoration: underline;" (click)="forceNavigation()">
            {{ "Click here" | translate }}{{" "}}
        </a>
        {{ "if you are not redirected automatically." | translate}}
    </span>
  </div>

  <div fxFill="100" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="2" *ngIf="errorState">
    <h1>{{ "Something went wrong. Please close this tab and try signing the forms again." | translate }}</h1>
    <p>{{ "If the problem persists, please contact your local Pathways location." | translate }}</p>
  </div>
</div>
